import $foreign from "./foreign.cjs";
var _getGlobalDefaultLocale = $foreign._getGlobalDefaultLocale;
var _getGlobalLocale = $foreign._getGlobalLocale;
var _interpolate = $foreign._interpolate;
var _setGlobalLocale = $foreign._setGlobalLocale;
var _translate = $foreign._translate;
var _translateIn = $foreign._translateIn;
export { _getGlobalDefaultLocale, _getGlobalLocale, _interpolate, _setGlobalLocale, _translate, _translateIn };
